import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPlans } from "../../Redux/Slice/Plans/GetPlansListSlice";
import { subscriptionType } from "../../Common/Constants";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { getPlanIntervalLabel } from "../../Common/utils";

export const PlanDetails = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    subscriptionType: "",
    planName: "",
    planId: "",
    expiryDate: "",
    credits: 0,
  });
  const [plansList, setPlansList] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState([]);
  const [hasChanged, setHasChanged] = useState(false);
  const [confirmModel, setCOnfirmModel] = useState(false);
  const plans = useSelector((state) => state.plansList.planDetails);
  useEffect(() => {
    fetchPlansList();
  }, []);

  const fetchPlansList = async (interval) => {
    await dispatch(getPlans({ interval }));
  };
  useEffect(() => {
    if (props?.isEdit === true) {
      const data = props.planDetails;
      if (props.planDetails) {
        const subscriptionTypeData = subscriptionType?.find(
          (itm) => itm.value == parseInt(data?.plan?.interval)
        );
        const planSelected = data?.plan;
        setFormData({
          id: data.id,
          subscriptionType: subscriptionTypeData?.value
            ? subscriptionTypeData?.value
            : planSelected?.id
            ? planSelected?.id
            : null,
          planId: data?.plan?.id,
          expiryDate: "",
          credits: data?.plan?.numberOfCredits,
        });
        setSelectedPlan(data?.plan);
      }
    }
  }, [props.planDetails]);

  useEffect(() => {
    if (plans) {
      setPlansList(plans?.data);
      if (!formData.planId && props?.isEdit != true) {
        const trialPolicy = Array.isArray(plans?.data)
          ? plans?.data?.find((plan) => plan?.isTrial == true)
          : null;
        if (trialPolicy) {
          setFormData({
            ...formData,
            planId: trialPolicy?.id,
            subscriptionType: trialPolicy?.id,
          });
          setSelectedPlan(trialPolicy);
        }
      }
    }
  }, [plans]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    if (name === "planId") {
      const planSelected = plansList.find((x) => x.id === value);
      setSelectedPlan(planSelected);
      const subscriptionTypeData = subscriptionType?.find(
        (itm) => itm.value == parseInt(planSelected?.interval)
      );
      setFormData({
        ...formData,
        [name]: value,
        subscriptionType: subscriptionTypeData?.value
          ? subscriptionTypeData?.value
          : planSelected?.id,
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = () => {
    props.setPlanDetails(formData);
    props.handleSubmit(formData);
  };

  const handleSubscriptionChange = (e) => {
    const { name, value } = e.target;
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    setFormData({ ...formData, planId: "", [name]: value });
    setSelectedPlan([]);
    fetchPlansList(value);
  };
  const handelNo = () => {
    setCOnfirmModel(false);
  };
  const handleCancel = () => {
    dispatch(setUnsavedChanges(false));
    setCOnfirmModel(false);
    navigate("/customers");
  };

  const isDisabledSubmitBtn = () => {
    return props?.isDisabledBtn;
  };

  const isFoundSubscriptionType = useMemo(() => {
    return subscriptionType?.find((i) => i.value == formData?.subscriptionType)
      ? true
      : false;
  }, [subscriptionType, formData?.subscriptionType]);

  return (
    <div
      className={
        props.selectedTab === 3
          ? "tabsContent__content tabsContent__content--selected"
          : "tabsContent__content"
      }
    >
      {confirmModel ? (
        <ConfirmModel
          onAccept={handleCancel}
          yes={"Yes"}
          no={"No"}
          onReject={handelNo}
          title="Update Changes!"
          message="Changes made will not be saved. Are you sure you want to leave the page?"
        />
      ) : (
        ""
      )}
      <div className="details">
        <div className="form">
          <section className="form__section">
            <h1 className="form__section__title">Plan</h1>
            <div className="formRow formRow__2">
              <div className="form__Field">
                <label for="planType" className="form__label">
                  Subscription Type
                </label>
                <select
                  className={`form__select form__select--sm ${
                    (
                      selectedPlan
                        ? selectedPlan?.isTrial ||
                          selectedPlan?.isExpiry == false
                        : false
                    )
                      ? "form__select--disabled"
                      : ""
                  }`}
                  name="subscriptionType"
                  value={formData.subscriptionType}
                  onChange={handleSubscriptionChange}
                  disabled={
                    selectedPlan
                      ? selectedPlan?.isTrial || selectedPlan?.isExpiry == false
                      : false
                  }
                >
                  <option value="" selected>
                    -Select-
                  </option>
                  {subscriptionType
                    ? subscriptionType.map((type) => (
                        <option value={type.value}>{type.label}</option>
                      ))
                    : ""}
                  {!isFoundSubscriptionType && formData.subscriptionType ? (
                    <option selected value={selectedPlan?.id}>
                      {getPlanIntervalLabel(selectedPlan)}
                    </option>
                  ) : null}
                </select>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="planId" className="form__label">
                    Plan Name
                  </label>
                  <select
                    className="form__select form__select--sm"
                    id="planId"
                    name="planId"
                    onChange={handleChange}
                    value={formData.planId}
                  >
                    <option disabled value="" selected>
                      -Select-
                    </option>
                    {plansList
                      ? plansList.map((plan) => (
                          <option value={plan.id}>{plan.name}</option>
                        ))
                      : ""}
                  </select>
                </div>
              </div>
            </div>
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label for="credits" className="form__label">
                    Credits
                  </label>
                  <input
                    type="number"
                    id="credits"
                    name="credits"
                    disabled={true}
                    value={selectedPlan?.numberOfCredits}
                    className="form__input form__input--sm"
                    placeholder="Credit"
                  />
                </div>
              </div>
            </div>
            <div className="btn__group">
              <button
                className="btn btn__white"
                type="button"
                onClick={() => {
                  if (hasChanged) {
                    setCOnfirmModel(true);
                  } else {
                    dispatch(setUnsavedChanges(false));
                    navigate("/customers");
                  }
                }}
              >
                Cancel
              </button>
              {props.isEdit ? (
                <button
                  className="btn btn__primary"
                  type="submit"
                  disabled={!hasChanged || isDisabledSubmitBtn()}
                  onClick={() => props.handleSubmit(formData)}
                >
                  Update
                </button>
              ) : (
                <button
                  className="btn btn__primary"
                  type="submit"
                  disabled={isDisabledSubmitBtn()}
                  onClick={handleSubmit}
                >
                  Save
                </button>
              )}
            </div>
          </section>
          {selectedPlan && selectedPlan?.name ? (
            <section className="form__section">
              <h1 className="form__section__title">Plan Details</h1>
              <ul className="planDetailList">
                <li className="planDetailList__item">
                  <strong>Plan Name: &nbsp;</strong>
                  {selectedPlan?.name}
                </li>
                <li className="planDetailList__item">
                  <strong>Subscription Type: &nbsp;</strong>
                  {getPlanIntervalLabel(selectedPlan)}
                </li>
                {/* <li className="planDetailList__item">
                  <strong>Expiry Date: &nbsp;</strong> 23/09/2023
                </li> */}
                <li className="planDetailList__item">
                  <strong>Credits: &nbsp;</strong>
                  {selectedPlan?.numberOfCredits}
                </li>
                <li className="planDetailList__item">
                  <strong>Plan Features: &nbsp;</strong>
                  {selectedPlan?.planTypeDetails?.features
                    ? selectedPlan?.planTypeDetails?.features.map(
                        (feat, i) => `${i + 1}. ${feat.name} `
                      )
                    : ""}
                </li>
                <li className="planDetailList__item">
                  <strong>Plan Description: &nbsp;</strong>
                  {selectedPlan?.description}
                </li>
              </ul>
            </section>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
